import { roleManagement } from "../../constants/path";
import { getHeader } from "../../utils/utils";
import instance from "../http";

export async function roleListingApi(_listingPerPage = 10, _listingPage = 1, search = '', organisation_uuid) {
    const headers = getHeader();
    /* roleManagement.ROLE_LISTING +`?project_uuid=${project_uuid}&perPage=${_listingPerPage}&page=${_listingPage}${search && `&search=${search}`}`, */
    const response = await instance.get(
        roleManagement.ROLE_LISTING + `?perPage=${_listingPerPage}&page=${_listingPage}${search && `&search=${search}`}&organization_uuid=${organisation_uuid}`,
        headers
    );
    return response;
}

export async function addRoleApi(values) {
    const headers = getHeader();
    const response = await instance.post(
        roleManagement.CREATE_ROLE,
        values,
        headers
    );
    return response;
}

export async function deleteRoleApi(roleId) {
    const headers = getHeader();
    const response = await instance.delete(roleManagement.DELETE_ROLE + roleId, headers);
    return response;
}

export async function moduleListingApi() {
    const headers = getHeader();
    const response = await instance.get(roleManagement.MODULE_LIST, headers);
    return response;
}

export async function getSingleRoleApi(id) {
    const headers = getHeader();
    const response = await instance.get(roleManagement.GET_SINGLE_ROLE + id, headers);
    return response;
}

export async function updateSignleRoleAPi(values, id) {
    const headers = getHeader();
    const response = await instance.patch(roleManagement.UPDATE_ROLE + id,
        values,
        headers
    );
    return response;
}

export async function activeRoleAPi(id) {
    const headers = getHeader();
    const response = await instance.patch(roleManagement.ACTIVE_ROLE + id, headers);
    return response;
}